import { useEffect, useState, useCallback } from 'react';
import { supabase } from '../../configs/supabase';
import { useAuthContext } from '../auth/AuthContext';
import { Customer } from '../types/customer';
import { DataFetchError } from '../../utils/ErrorClass';

const useShips = () => {
  const { state } = useAuthContext();
  const [ships, setShipments] = useState<Customer[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const fetchShips = useCallback(async () => {
    try {
      if (state.customerId !== -1) {
        const { data: customerShips, error: customerShipsError } = await supabase
          .from('customerShip')
          .select('ship_id')
          .eq('customer_id', state.customerId);

        if (customerShipsError) {
          throw new DataFetchError('Error fetching customer ships');
        }

        const shipIds = customerShips.map((cs: { ship_id: number }) => cs.ship_id);

        const { data: ships, error: shipsError } = await supabase
          .from('customer')
          .select('*')
          .in('id', shipIds);

        if (shipsError) {
          throw new DataFetchError('Error fetching ships');
        } else {
          // customerIdとshipIdが一致するものを最初に表示
          const matchingShip = ships.find((ship: Customer) => ship.id === state.customerId);
          if (matchingShip) {
            // 配列の先頭に追加
            setShipments([matchingShip, ...ships.filter((ship: Customer) => ship.id !== state.customerId)]);
          } else {
            setShipments(ships as Customer[]);
          }
        }
      }
    } catch (err) {
      if (err instanceof DataFetchError) {
        setError(err.message);
      } else {
        setError('予期せぬエラーが発生しました。');
      }
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [state.customerId]);

  useEffect(() => {
    fetchShips();
  }, [fetchShips]);

  return { ships, loading, error };
};

export default useShips;
